import { render, staticRenderFns } from "./check.vue?vue&type=template&id=78508246&"
import script from "./check.vue?vue&type=script&lang=js&"
export * from "./check.vue?vue&type=script&lang=js&"
import style0 from "./check.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports